export default ({ savedItems: { sort, indicatives } }) =>
  indicatives.sort || sort;
